export enum BehandlungArt {
  OPERATIVER_EINGRIFF = 'OPERATIVER_EINGRIFF',
  REHA = 'REHA',
  PHYSIKALISCHE_THERAPIE = 'PHYSIKALISCHE_THERAPIE',
  MEDIKATION = 'MEDIKATION',
  ANDERE = 'ANDERE',
}

export const behandlungsArtToLabel: Map<BehandlungArt, string> = new Map([
  [BehandlungArt.OPERATIVER_EINGRIFF, 'Operativer Eingriff'],
  [BehandlungArt.REHA, 'Reha'],
  [BehandlungArt.PHYSIKALISCHE_THERAPIE, 'Physikalische Therapie'],
  [BehandlungArt.MEDIKATION, 'Medikation'],
  [BehandlungArt.ANDERE, 'Andere'],
]);
